export const extractFirstNumber = (str: string): number | null => {
    const match = str.match(/\d+/) // Match the first sequence of digits
    return match ? Number(match[0]) : null
}
